import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import ChangePasswordModal from './components/ChangePasswordModal';
import { AuthProvider, useAuth } from './context/AuthContext';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import ServicesPage from './pages/ServicesPage';
import UsersPage from './pages/UsersPage';
import PublicStatusPage from './pages/PublicStatusPage';
import IncidentsPage from './pages/IncidentsPage';
const ProtectedRoute = ({ children }) => {
    const { token } = useAuth();
    const location = useLocation();
    if (!token) {
        return (_jsx(Navigate, { to: "/login", replace: true, state: { from: location.pathname + location.search } }));
    }
    return children;
};
const AdminRoutes = () => {
    const { user, updateUser } = useAuth();
    const mustChange = Boolean(user?.mustChangePassword);
    return (_jsxs(_Fragment, { children: [_jsx(ChangePasswordModal, { open: mustChange, force: mustChange, onClose: () => undefined, onChanged: () => {
                    if (user) {
                        updateUser({ ...user, mustChangePassword: false });
                    }
                } }), _jsxs(Routes, { children: [_jsx(Route, { path: "", element: _jsx(DashboardPage, {}) }), _jsx(Route, { path: "services", element: _jsx(ServicesPage, {}) }), _jsx(Route, { path: "incidents", element: _jsx(IncidentsPage, {}) }), _jsx(Route, { path: "users", element: _jsx(UsersPage, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/admin", replace: true }) })] })] }));
};
const AppRoutes = () => (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(PublicStatusPage, {}) }), _jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { path: "/admin/*", element: _jsx(ProtectedRoute, { children: _jsx(AdminRoutes, {}) }) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }));
const App = () => {
    return (_jsx(AuthProvider, { children: _jsx(BrowserRouter, { children: _jsx(AppRoutes, {}) }) }));
};
export default App;
